import styled from "styled-components";

const WrestlerNameContainer = styled.h1`
    margin: 0 !important;
    text-align: center;
    text-transform: uppercase;
`;

function WrestlerName({ wrestlerData }: any) {
    return (
        <WrestlerNameContainer className="name-wres">
            {wrestlerData.name.toUpperCase()}
        </WrestlerNameContainer>
    );
}

export default WrestlerName;
